var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.handleSubmit.apply(null, arguments);
      }
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "6"
    }
  }, [_c('label', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v(" Fleet Name "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _c('v-select', {
    attrs: {
      "options": _vm.vehicleOptions,
      "label": "name",
      "reduce": function reduce(option) {
        return option === null || option === void 0 ? void 0 : option.id;
      },
      "placeholder": "Select Fleet...",
      "disabled": !!_vm.selectedData
    },
    on: {
      "input": _vm.handleVehicleSelect
    },
    model: {
      value: _vm.form.vehicle_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "vehicle_id", $$v);
      },
      expression: "form.vehicle_id"
    }
  })], 1), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "6"
    }
  }, [_c('label', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v(" Engine "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _c('v-select', {
    attrs: {
      "options": _vm.vehiclePowerOptions,
      "label": "engineName",
      "reduce": function reduce(option) {
        return option === null || option === void 0 ? void 0 : option.id;
      },
      "placeholder": "Select Engine..."
    },
    model: {
      value: _vm.form.vehicle_power_id,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "vehicle_power_id", $$v);
      },
      expression: "form.vehicle_power_id"
    }
  })], 1), _c('b-col', {
    staticClass: "mb-3 d-flex flex-column",
    attrs: {
      "md": "6"
    }
  }, [_c('label', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v(" Effective Date "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _c('date-picker', {
    staticClass: "text-black w-100",
    attrs: {
      "value-type": "YYYY-MM-DD",
      "type": "date",
      "placeholder": "Select date",
      "format": "DD-MM-YYYY",
      "input-attr": {
        required: true
      }
    },
    model: {
      value: _vm.form.effective_date,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "effective_date", $$v);
      },
      expression: "form.effective_date"
    }
  })], 1), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "6"
    }
  }, [_c('label', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v(" Kick Off GOH (Hours) "), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v("*")])])]), _c('InputCurrency', {
    attrs: {
      "prepend": "",
      "placeholder": "Enter hours"
    },
    model: {
      value: _vm.form.kick_off_goh,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "kick_off_goh", $$v);
      },
      expression: "form.kick_off_goh"
    }
  })], 1), _c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "md": "12"
    }
  }, [_c('label', {
    staticClass: "mb-2"
  }, [_c('strong', [_vm._v("Remarks")])]), _c('b-form-textarea', {
    attrs: {
      "rows": "4",
      "placeholder": "Enter remarks..."
    },
    model: {
      value: _vm.form.remarks,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "remarks", $$v);
      },
      expression: "form.remarks"
    }
  })], 1)], 1), _c('div', {
    staticClass: "d-flex"
  }, [_c('b-button', {
    staticClass: "w-50 mr-3",
    attrs: {
      "variant": "outline-primary",
      "type": "button"
    },
    on: {
      "click": function click($event) {
        return _vm.$emit('close');
      }
    }
  }, [_vm._v(" Cancel ")]), !_vm.loading ? _c('b-button', {
    staticClass: "w-50",
    attrs: {
      "variant": "primary",
      "type": "submit"
    }
  }, [_vm._v(" Submit ")]) : _c('b-button', {
    staticClass: "w-50",
    attrs: {
      "variant": "primary",
      "disabled": ""
    }
  }, [_c('b-spinner', {
    staticClass: "mr-1",
    attrs: {
      "small": ""
    }
  }), _vm._v(" Saving... ")], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }